import { render, staticRenderFns } from "./base-autocomplete.vue?vue&type=template&id=4f647a81&scoped=true&"
import script from "./base-autocomplete.vue?vue&type=script&lang=js&"
export * from "./base-autocomplete.vue?vue&type=script&lang=js&"
import style0 from "./base-autocomplete.vue?vue&type=style&index=0&id=4f647a81&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f647a81",
  null
  
)

export default component.exports